import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/ADD_PAYMENT_METHOD_MODAL';

export const {action: showPaymentMethodModal} = createAction(`${domain}/SHOW`, (billPayerId, institutionId) => ({
    billPayerId,
    institutionId,
}));

export const {action: hidePaymentMethodModal} = createAction(`${domain}/HIDE`, () => ({}));
